import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extracts the short numeric ID from a product slug.
 * Slugs end with a numeric suffix (e.g. "panda-bei-bei-...-758213260" -> "758213260").
 * Falls back to the full slug if no numeric suffix is present.
 */
export function productShortId(slug?: string | null): string {
  if (!slug) return '';
  const m = String(slug).match(/(\d+)$/);
  return m ? m[1] : String(slug);
}
